module.exports = __webpack_public_path__ + "img/ballot.a60a2b1e.png";